<template lang="pug">
  #app.app
    Rotation
    router-view(v-if="isLoaded")
</template>

<script>
import { mapMutations } from 'vuex';

import Rotation from '@/components/UI/Rotation';

export default {
  name: 'App',
  components: { Rotation },
  methods: {
    ...mapMutations(['set_tries', 'set_bestScore', 'set_token', 'set_name']),
  },
  mounted() {
    this.$router.push({ name: 'Hello' });
    this.isLoaded = true;
  },
  data() {
    return {
      isLoaded: false,
    };
  },
};
</script>

<style lang="scss">
  @import './scss/normalize.scss';

  .app {
    @include vertical-align;
    justify-content: center;
    flex-direction: column;
    padding: 60px 0 80px;
    min-height: 100vh;
    @media (max-width: $max-width-xs) {
      padding: 0;
      align-items: stretch;
      justify-content: flex-start;
      min-height: 0;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue